/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type ConceptRelationType = (typeof ConceptRelationType)[keyof typeof ConceptRelationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConceptRelationType = {
  related_to: 'related_to',
  prerequisite_for: 'prerequisite_for',
  part_of: 'part_of',
  leads_to: 'leads_to',
} as const;
